import React, { useState } from "react";

import { useNavigate } from "@tanstack/react-router";

import { useGetProjectById } from "@synthesis/shared-services/project-gge/projectController/hooks";
import { updateProject } from "@synthesis/shared-services/project-gge/projectController/client";
import { Button, Modal, useManualModalState } from "@synthesis/shared-ui";
import { logger } from "@synthesis/shared-utils";

type ModalProps = {
  trigger: React.ReactNode;
  id: string;
  title: string;
  isArchived: boolean;
  isIntegration: boolean;
};

type ModalContentProps = Omit<ModalProps, "trigger">;

export const ModalArchiveProject = ({ trigger, id, title, isArchived, isIntegration }: ModalProps) => (
  <Modal.Root manual trigger={trigger as React.ReactElement}>
    <ModalContent id={id} title={title} isArchived={isArchived} isIntegration={isIntegration} />
  </Modal.Root>
);

const ModalContent = ({ id, title, isArchived, isIntegration }: ModalContentProps) => {
  const [integrationWarning, setIntegrationWarning] = useState(!!isIntegration);
  const { closeModal } = useManualModalState();
  const navigate = useNavigate();
  const { data: project } = useGetProjectById({ path: { id } });

  const handleArchived = async () => {
    try {
      await updateProject({ body: { id, isArchived: !isArchived, type: project?.type ?? "SIMPLE" } });
      closeModal();
      await navigate({ to: isArchived ? "/" : "/archivedProjects" });
      window.location.reload();
    } catch (error) {
      logger.error("error in onArchived project Admin", error);
    }
  };

  return (
    <Modal.Content className="min-w-[550px]">
      <Modal.Title>{isArchived ? "Разархивация проекта" : "Архивация проекта"}</Modal.Title>
      {integrationWarning ? (
        <Modal.Description className="p-8">
          <h2 className="heading-h4">Проект &quot;{title}&quot; - создан по интеграции</h2>
          <div className="paragraph-lg py-4">Данные получены по интеграции. Продолжить?</div>
          <div className="flex justify-between">
            <Button theme="primary" onClick={closeModal}>
              Нет
            </Button>
            <Button theme="secondary" onClick={() => setIntegrationWarning(false)}>
              Да
            </Button>
          </div>
        </Modal.Description>
      ) : (
        <Modal.Description className="p-8">
          <h2 className="heading-h4">{isArchived ? "Вернуть данный проект из архива?" : "Архивировать данный проект?"}</h2>
          <div className="paragraph-lg py-4">
            Вы уверены, что хотите {isArchived ? `вернуть проект ${title} из архива?` : `отправить проект ${title} в архив?`}
          </div>
          <div className="flex justify-between">
            <Button theme="primary" onClick={handleArchived}>
              {isArchived ? "Вернуть из архива" : "Архивировать проект"}
            </Button>
            <Button theme="secondary" onClick={closeModal}>
              Отменить
            </Button>
          </div>
        </Modal.Description>
      )}
    </Modal.Content>
  );
};
